import _ from "lodash";
import React, { useCallback } from "react";
import { CellRenderers } from "utils/tableUtils";

import GenericIntegrationTicketSystemListing from "../GenericIntegrationTicketSystemListing";
import {
  GenericIntegrationTicketDefaultValues,
  GenericIntegrationTicketSystemListingProps,
} from "../genericIntegrationTicketConstants";

function GitLabIssuesIntegrationListing({
  loginConfigList,
  loading,
  ...props
}: GenericIntegrationTicketSystemListingProps) {
  const getColumns = useCallback((columns) => {
    const updatedColumns = columns.map((col: any) => {
      // git lab issues gets projectKey value from custom field since an earlier implementation
      if (col.dataIndex === "projectKey") {
        col.showFilter = false;
        col.showSort = false;
        col.render = (
          projectKey: string,
          record: GenericIntegrationTicketDefaultValues,
        ) => {
          const project = _.find(
            record.customFields,
            (field) => field.key === "projectValue",
          );
          return CellRenderers.VALUE_OR_NA(project?.name || projectKey);
        };
      }
      return col;
    });
    return updatedColumns;
  }, []);
  return (
    <div>
      <GenericIntegrationTicketSystemListing
        loginConfigList={loginConfigList}
        loading={loading}
        getColumns={getColumns}
        {...props}
      />
    </div>
  );
}

export default GitLabIssuesIntegrationListing;
